export const cardImageConfig = {
  smSize: { width: 312, height: 390 },
  mdSize: { width: 320, height: 400 },
  lgSize: { width: 692, height: 864 },
  xlSize: { width: 692, height: 864 },
};

export const smallCardImageConfig = {
  smSize: { width: 312, height: 250 },
  mdSize: { width: 320, height: 256 },
  lgSize: { width: 258, height: 206 },
  xlSize: { width: 320, height: 256 },
};

export const twoImageHeroConfig = {
  smSize: { width: 320, height: 400 },
  mdSize: { width: 564, height: 705 },
  lgSize: { width: 704, height: 880 },
  xlSize: { width: 828, height: 1035 },
};
